import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { Shutters89mmClearViewFaceFit } from './Shutters89mmClearViewFaceFit';
import { Shutters89mmClearViewMidRailFaceFit } from './Shutters89mmClearViewMidRailFaceFit';
import { Shutters89mmClearViewMidRailRevealFit } from './Shutters89mmClearViewMidRailRevealFit';
import { Shutters89mmClearViewRevealFit } from './Shutters89mmClearViewRevealFit';
import { Shutters89mmTiltControlFaceFit } from './Shutters89mmTiltControlFaceFit';
import { Shutters89mmMidRailTiltControlFaceFit } from './Shutters89mmTiltControlMidRailFaceFit';
import { Shutters89mmTiltControlMidRailRevealFit } from './Shutters89mmTiltControlMidRailRevealFit';
import { Shutters89mmTiltControlRevealFit } from './Shutters89mmTiltControlRevealFit';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89 = ({ patternUrl, ...props }: ShuttersProps) => {
  const [state] = useService(productBuilderMachine);
  const operation =
    state.context.custom.operation === 'Control Bar'
      ? 'Control Bar'
      : 'Clear View';

  const fitting = state.context.custom.fitting;

  const [width, height] = state.context.custom.measurements
    ? (state.context.custom.measurements as string)
        .split('x')
        .map(value => parseInt(value))
    : ['', ''];

  if (operation === 'Clear View' && height > 2034 && fitting === 'Reveal Fit') {
    return (
      <Shutters89mmClearViewMidRailRevealFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation === 'Clear View' &&
    (height === '' || height <= 2034) &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters89mmClearViewRevealFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation === 'Control Bar' &&
    (height === '' || height <= 2034) &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters89mmTiltControlRevealFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation === 'Control Bar' &&
    height > 2034 &&
    fitting === 'Reveal Fit'
  ) {
    return (
      <Shutters89mmTiltControlMidRailRevealFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation === 'Control Bar' &&
    (height === '' || height <= 2030) &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters89mmTiltControlFaceFit patternUrl={patternUrl} {...props} />
    );
  } else if (
    operation === 'Control Bar' &&
    height > 2030 &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters89mmMidRailTiltControlFaceFit
        patternUrl={patternUrl}
        {...props}
      />
    );
  } else if (
    operation === 'Clear View' &&
    height > 2030 &&
    fitting === 'Face Fit'
  ) {
    return (
      <Shutters89mmClearViewMidRailFaceFit patternUrl={patternUrl} {...props} />
    );
  } else {
    return <Shutters89mmClearViewFaceFit patternUrl={patternUrl} {...props} />;
  }
};
